import React from 'react';
import LineChart from '../../charting/LineChart/LineChart.jsx';
const chartstyles= {
  width   : "100%",
  paddingLeft : 30,
  paddingRight: 10,
  paddingTop: 10,
  paddingBottom: 20
};

const yearFormat = function(date,truncate) {
    if(truncate) { return "‘"+date.toString().slice(-2) };
    return date;
}

let seriesdata = [
    {
        "name": "East Asia & Pacific",
        "color": "#009688",
        "series": [
            [
                2000,
                111180913
            ],
            [
                2001,
                115948099
            ],
            [
                2002,
                137479148
            ],
            [
                2003,
                151803542
            ],
            [
                2004,
                174201309
            ],
            [
                2005,
                193780272
            ],
            [
                2006,
                217761320
            ],
            [
                2007,
                252296411
            ],
            [
                2008,
                269311779.7
            ],
            [
                2009,
                247674210.41178
            ],
            [
                2010,
                287158379.275091
            ],
            [
                2011,
                313327039.402671
            ],
            [
                2012,
                330439510.581071
            ],
            [
                2013,
                353293607.130018
            ],
            [
                2014,
                370303650.122399
            ]
        ]
    },
    {
        "name": "Europe & Central Asia",
        "color": "#5b0003",
        "series": [
            [
                2000,
                48312150
            ],
            [
                2001,
                50660187
            ],
            [
                2002,
                55628833
            ],
            [
                2003,
                60321993
            ],
            [
                2004,
                71190112
            ],
            [
                2005,
                75798358
            ],
            [
                2006,
                81291535
            ],
            [
                2007,
                97542316
            ],
            [
                2008,
                98520362.3448
            ],
            [
                2009,
                84176404.3570037
            ],
            [
                2010,
                94758103.607105
            ],
            [
                2011,
                103743543.185244
            ],
            [
                2012,
                108741114.66559
            ],
            [
                2013,
                112485103.827697
            ],
            [
                2014,
                116400705.130754
            ]
        ]
    },
    {
        "name": "Middle East & North Africa",
        "color": "#e57175",
        "series": [
            [
                2007,
                36285930
            ],
            [
                2008,
                41994620.9208
            ],
            [
                2009,
                42545025.3235755
            ],
            [
                2010,
                46519534.6136712
            ],
            [
                2011,
                50694999.7416504
            ],
            [
                2012,
                52975362.5472742
            ],
            [
                2013,
                55790048.190344
            ],
            [
                2014,
                56172746.4392648
            ]
        ]
    },
    {
        "name": "North America",
        "color": "#e5982b",
        "series": [
            [
                2000,
                31227942
            ],
            [
                2001,
                30197964
            ],
            [
                2002,
                32984200
            ],
            [
                2003,
                36320556
            ],
            [
                2004,
                38827775
            ],
            [
                2005,
                42661263
            ],
            [
                2006,
                45226905
            ],
            [
                2007,
                49253317
            ],
            [
                2008,
                47132433.0512
            ],
            [
                2009,
                41545142.966
            ],
            [
                2010,
                47167319.605143
            ],
            [
                2011,
                47823577.6749342
            ],
            [
                2012,
                49515124.6005542
            ],
            [
                2013,
                49638811.193517
            ],
            [
                2014,
                52066528.6483863
            ]
        ]
    },
    {
        "name": "Latin America & Caribbean",
        "color": "#e5ce89",
        "series": [
            [
                2000,
                15860053
            ],
            [
                2001,
                16129381
            ],
            [
                2002,
                15090170
            ],
            [
                2003,
                19556512
            ],
            [
                2004,
                22294663
            ],
            [
                2005,
                24816487
            ],
            [
                2006,
                28018282
            ],
            [
                2007,
                32720909
            ],
            [
                2008,
                35627766.8832
            ],
            [
                2009,
                32630749.9822672
            ],
            [
                2010,
                40100971.1541242
            ],
            [
                2011,
                42179257.2889093
            ],
            [
                2012,
                44640003.4518025
            ],
            [
                2013,
                47660000.7593733
            ],
            [
                2014,
                49456707.1626748
            ]
        ]
    },
    {
        "name": "South Asia",
        "color": "#bbbbbb",
        "series": [
            [
                2000,
                4639518
            ],
            [
                2001,
                5856543
            ],
            [
                2002,
                5557320
            ],
            [
                2003,
                7288887
            ],
            [
                2004,
                8537181
            ],
            [
                2005,
                9932668
            ],
            [
                2006,
                11898747
            ],
            [
                2007,
                14047141
            ],
            [
                2008,
                14442773
            ],
            [
                2009,
                14774961.2
            ],
            [
                2010,
                17323023
            ],
            [
                2011,
                18241747.621
            ],
            [
                2012,
                18354898.04895
            ],
            [
                2013,
                19173311.576817
            ],
            [
                2014,
                20900073.2572348
            ]
        ]
    }
];

seriesdata = seriesdata.map((obj) => {
    obj.series = obj.series.map(val => [new Date(""+val[0]),val[1]]);
    return obj;
})
const chartdata = {
    data: seriesdata,
    xTicks: [new Date("2000"),new Date("2005"),new Date("2010")],
    yTicks: [0,100000000,200000000,300000000,400000000],
    xTickFormat: function(val,i) { return yearFormat(val.getFullYear(),i!=0); },
    yTickFormat: function(val,i) { return val/1000000; },
    tooltipTitle: function(x) { return `Traffic in ${x.getFullYear()} (in TEU)`; },
    tooltipFormatter: function(name,x,y) { return name+": " + Math.round(y/1000000)+"m"},
    
}

export default (props) => {
    return <LineChart height={props.height} {...chartstyles} {...chartdata}/>
}


// WEBPACK FOOTER //
// ./src/js/components/special/TrafficChart/TrafficChart.jsx